import {
  GET_REGISTER_ENTITY_TYPES,
  LOGIN_URL,
  OTP_SENT,
  REGISTER_USER_ENTITY,
  URL_FORGOT_PASSWORD,
  get_headers,
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import { password_visibility_mixin } from '@/utils/mixins/password_visibility_mixin.js';
import {
  validate_non_empty_string,
  validate_non_sub_zero_number,
  validate_phone_number
} from '@/utils/validations/validate_inputs';
import OnboardingIndex from '@/views/onboarding/OnboardingIndex.vue';
import axios from 'axios';


export default {
   name: 'SignUp',
   mixins: [alert_mixin, password_visibility_mixin],
  components:{
    OnboardingIndex
  },
  data: () => ({
    show_password: false, // Toggle for password visibility
    show_confirm_password: false,
    first_name: '',
    last_name: '', 
    email: '', 
    phone_number: '',
    password: '',
    confirm_password: '',
    entity_type_id :'',
    eye_icon: 'bi-eye-slash', 
    url_forgot_password: URL_FORGOT_PASSWORD,
    url_login:LOGIN_URL,
    verification_running: false, 
    title: "Sign up to your account", 
    submitButtonText: "Sign Up",
    entity_type_list :[],
    dec_project_id:'',
    username:'',
    login_password:'',
    verify_acc_message:'',
    token:'',
    user_id: null,
    headers:{},
 }),

  mounted() {
    this.get_default_entity_types();
  },

  methods: {

    get_default_entity_types(){
      const project_id = this.$route.params.project_id || ""

      axios.get(GET_REGISTER_ENTITY_TYPES,{
        params: { project_id: project_id }
      })
      .then(response => {
          const response_data = response.data;

          if (response_data.status === 'success') {
              this.dec_project_id = response_data.project_id
              const mapped_request_data = response_data.data.map(entity_type => ({
                  "id": entity_type.id,
                  "name": entity_type.entity_type_name,
                }),
              );

              this.entity_type_list = mapped_request_data
          } else {
              this.show_error('Error fetching requests');
          }
      })
      .catch(error => {
          if (error.response && error.response.data) {
              this.show_error(error.response.data.message);
          }
      });
    },


    async sign_up_function(){

      if (!this.validate_register_entity_user_inputs()) return;

      const data = {
        first_name:this.first_name,
        last_name:this.last_name,
        email:this.email,
        phone_number:this.phone_number,
        password: this.password,
        login_password: this.login_password,
        entity_type_id :this.entity_type_id,
        project_id : this.dec_project_id
      };

      axios.post(REGISTER_USER_ENTITY, data)
      .then(response => {
        var response_data = JSON.parse(response.data);

        if (response_data.status === 'success') {

          this.token = response_data.token;
          this.user_id = response_data.user_id;
          sessionStorage.setItem('user_id', response_data.user_id);
          sessionStorage.setItem('token', response_data.token);
          sessionStorage.setItem('user_role', response_data.role_type);
          this.headers = get_headers();
          this.handle_successful_registration(response_data.user_id);
          this.$refs.trigger_close_modal_btn.click();

        } else {
          this.verify_acc_message = response_data.message;
          this.$refs.trigger_modal_btn.click();
        }
      })
      .catch(error => {
        if (error.response && error.response.data) {
          let error_data = error.response.data;

          // Parse if it's a string
          if (typeof error_data === 'string') {
            try {
              error_data = JSON.parse(error_data);
            } catch (e) {
              // If parsing fails, show raw message or fallback
              return this.show_error('Error: email or phone number already exists: ',e);
            }
          }

          this.show_error(error_data.message || 'Error: email or phone number already exists');
        } else {
          this.show_error('Error: Something went wrong');
        }
      });
    },

    validate_register_entity_user_inputs() {
      if (!validate_non_sub_zero_number(this.entity_type_id)) {
          this.show_error('Please select an Entity Type');
          return false;
      }

      if (!validate_non_empty_string(this.first_name)) {
          this.show_error('First name must not be empty');
          return false;
      }

      if (!validate_non_empty_string(this.last_name)) {
          this.show_error('Last name must not be empty');
          return false;
      }
      if (!validate_non_empty_string(this.email)) {
        this.show_error('Email must not be empty');
        return false;
      }
      if (!validate_non_empty_string(this.phone_number)) {
        this.show_error('Phone number must not be empty');
        return false;
      }

      if (this.password !== this.confirm_password) {
        this.show_info('Passwords do not match.');
        return false;
      }

      return true;
    },
    async handle_successful_registration() {
      var data = {
        user_id: this.user_id
      };
      try {
        await axios.post(OTP_SENT, data, {
          headers: this.headers,
        });
        sessionStorage.setItem('first_time_login', true);
        // Pass user_id and token as query parameters
        var token = this.token
        var user_id = this.user_id
        this.$router.push({
          path: '/one_time_pin',
          query: {
            user_id,
            token,
          }
        });

      } catch (error) {
        this.show_error('Could not send OTP to user.');
      }
    },

    validate_phone_number(phone_number) {
      return validate_phone_number(phone_number)
    }
  },
};
